/* ============================================================================
   config.ts — the two facts this package cannot discover for itself.

   `@hk/core` is consumed by a Vite web application and by a React Native
   application. Neither `import.meta.env` nor `process.env` exists in both, so a shared
   module that reads either one is a shared module that only works in one place. The
   host tells the core what it needs at startup, once.

   It is a function rather than a constant so that a test can point the client at a
   stub, and so that a handset can be moved between environments without a rebuild
   when that eventually matters.
   ========================================================================= */

export interface CoreConfig {
  /** e.g. "/api/v1" in the browser, "https://host/api/v1" on a handset, which has no
   *  origin of its own to be relative to. */
  apiBaseUrl: string

  /** The development identity, until TQ-01 is answered. See session.ts. */
  developmentUserId: string
}

let current: CoreConfig | null = null

export function configureCore(config: CoreConfig): void {
  current = config
}

export function coreConfig(): CoreConfig {
  if (!current)
    // Loud, and named. A default would let an application ship pointing at the wrong
    // host and only discover it when every request 404s in an environment nobody can
    // reach with a debugger.
    throw new Error(
      'configureCore() has not been called. The host application must supply the API '
      + 'base URL before any request is made — see app/core/README.md.')
  return current
}

/** For tests, which need to put it back. */
export function resetCoreConfig(): void {
  current = null
}
